import { Component } from '@angular/core';
import { NavController,NavParams } from 'ionic-angular';

/*import { HttpService } from '../../../../providers/service/httpservice';
import { StorageService } from '../../../../providers/service/storageservice';
import { Utils } from '../../../../providers/service/utils';*/
import { AppState } from '../../../../../app/app.global';

@Component({
  selector: 'page-contactinfo',
  templateUrl: 'contactinfo.html'
})
export class ContactInfo {
	contact:any;
  constructor(public navCtrl: NavController,public params: NavParams,public global: AppState) {
			this.contact =  params.data.contact;
			console.log(this.contact);
  }
}



// WEBPACK FOOTER //
// ./src/pages/application/dailyoffice/contact/contactinfo/contactinfo.ts